export default "__VITE_ASSET__B_$oS6Wt__"